export default __webpack_public_path__ + "static/media/calendar-icon--google-calendar.1996396d.svg";